import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useMapGetter } from 'dashboard/composables/store';
import { CONTACT_EDIT_PERMISSIONS } from 'dashboard/constants/permissions';
import {
  getUserPermissions,
  getUserRole,
} from 'dashboard/helper/permissionsHelper';

/**
 * When account feature lock_contact_edit_for_agents is enabled, agents cannot edit
 * contact name or phone (enforced in API; UI should disable those inputs).
 * Agents with the contact_edit_manage custom role permission bypass this lock.
 */
export function useContactProfileIdentityLock() {
  const route = useRoute();
  const getCurrentUser = useMapGetter('getCurrentUser');
  const getCurrentRole = useMapGetter('getCurrentRole');
  const isFeatureEnabledonAccount = useMapGetter(
    'accounts/isFeatureEnabledonAccount'
  );

  const accountId = computed(() => Number(route.params.accountId));

  const userPermissions = computed(() =>
    getUserPermissions(getCurrentUser.value, accountId.value)
  );

  const hasCustomRole = computed(() =>
    getUserRole(getCurrentUser.value, accountId.value) === 'custom_role'
  );

  const canEditContactProfile = computed(() => {
    if (getCurrentRole.value === 'administrator') return true;
    if (hasCustomRole.value) {
      return userPermissions.value.includes(CONTACT_EDIT_PERMISSIONS);
    }

    return true;
  });

  const isContactIdentityLockedForCurrentUser = computed(() => {
    if (!accountId.value) return false;
    if (getCurrentRole.value !== 'agent') return false;
    if (
      hasCustomRole.value &&
      userPermissions.value.includes(CONTACT_EDIT_PERMISSIONS)
    ) {
      return false;
    }

    return Boolean(
      isFeatureEnabledonAccount.value(
        accountId.value,
        'lock_contact_edit_for_agents'
      )
    );
  });

  return { isContactIdentityLockedForCurrentUser, canEditContactProfile };
}
